import { gql } from '@apollo/client';

export const AGENT_PROFILE_FRAGMENT = gql`
  fragment AgentProfileFragment on AgentProfile {
    id
    uuid
    status
  }
`;
